import services from './../../../services/service'; // Service Class
import CartWidget from '../CartWidget/index.vue'

let service = new services();

export default {
    name: 'Order',
    data () {
        return {
          loading:false,
          user: {},
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          loggedIn:false,
        }
      },
    components: {
       'cart-widget': CartWidget,
      },
    computed: {
       
    },
    methods:{
        
    

    },
    created(){
        document.title = "Order" + " | Gallery";
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Order/script.js